
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode';

createApp(App).use(store).use(router).use(VueQrcode).mount('#app');
